export default __webpack_public_path__ + "dd3dedbc047b8b1e8fdddbed45e812b4.png";